module.exports = __webpack_public_path__ + "img/logo.5cae59f4.png";